import type {RouteLocationNormalizedLoaded} from 'vue-router';
import {activeOrderStatuses} from '@myparcel-frontend/order-service';

export const buildOrdersOverviewProps = (route: RouteLocationNormalizedLoaded) => {
  const filter: Record<string, unknown> = {};

  filter.status = route.query.status ?? activeOrderStatuses;

  ['carrier', 'regionCode', 'packageType'].forEach((key) => {
    const value = route.query[key];
    if (value) {
      filter[key] = Array.isArray(value) ? value : [value];
    }
  });

  return {
    query: {
      query: route.query.query,
      filter,
    },
    allShops: route.query.allShops === 'true',
    orderedAt: route.query.orderedAt,
    periodFrom: route.query.periodFrom,
    periodUntil: route.query.periodUntil,
  };
};
